//@flow

// export const Pending = Symbol('@async-value/pending');
// export const Complete = Symbol('@async-value/complete');
export const Pending = '@async-value/pending';
export const Complete = '@async-value/complete';

export type AsyncValueType<T = typeof Complete> = typeof Pending | Error | T;

export class AsyncValues {
  static Pending = Pending;
  static Complete = Complete;
}

export default AsyncValues;



// WEBPACK FOOTER //
// ./src/lib/async-value.js